import React from 'react';
import { useTranslation } from 'react-i18next';

const AIStoryboard = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-[1200px] mx-auto p-8 font-[-apple-system,BlinkMacSystemFont,'Segoe_UI',Roboto,'Helvetica_Neue',Arial,sans-serif]">
      <header className="text-center mb-12">
        <h1 className="text-[2.5rem] font-semibold">{t('storyboard.title')}</h1>
        <p className="text-gray-500">{t('storyboard.subtitle')}</p>
      </header>

      <div className="mb-12">
        {/* Step 1: Core Settings */}
        <section className="flex items-start mb-10 border-b border-gray-100 pb-10 last:border-b-0 last:pb-0">
          <div className="text-[2rem] font-bold text-gray-300 mr-8 leading-none">1</div>
          <div className="flex-grow">
            <h2 className="mt-0 text-[1.8rem] font-medium">{t('storyboard.step1.title')}</h2>
            <p className="text-gray-600 mb-4">{t('storyboard.step1.description')}</p>
            <button className="px-6 py-3 border-none bg-blue-500 text-white rounded-lg text-base font-medium cursor-pointer transition-colors duration-300 hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed" disabled>{t('storyboard.step1.button')}</button>
          </div>
        </section>

        {/* Step 2: Scene Input */}
        <section className="flex items-start mb-10 border-b border-gray-100 pb-10 last:border-b-0 last:pb-0">
          <div className="text-[2rem] font-bold text-gray-300 mr-8 leading-none">2</div>
          <div className="flex-grow">
            <h2 className="mt-0 text-[1.8rem] font-medium">{t('storyboard.step2.title')}</h2>
            <p className="text-gray-600 mb-4">{t('storyboard.step2.description')}</p>
            <textarea
              className="w-full p-3 rounded-lg border border-gray-300 font-inherit text-base resize-y"
              placeholder={t('storyboard.step2.placeholder')}
              rows="4"
            ></textarea>
          </div>
        </section>

        {/* Step 3: AI Generation */}
        <section className="flex items-start mb-10 border-b border-gray-100 pb-10 last:border-b-0 last:pb-0">
          <div className="text-[2rem] font-bold text-gray-300 mr-8 leading-none">3</div>
          <div className="flex-grow">
            <h2 className="mt-0 text-[1.8rem] font-medium">{t('storyboard.step3.title')}</h2>
            <p className="text-gray-600 mb-4">{t('storyboard.step3.description')}</p>
            <div className="bg-gray-50 border border-dashed border-gray-300 rounded-lg p-8 text-center text-gray-500 my-4">
              <p>{t('storyboard.step3.placeholder')}</p>
            </div>
            <button className="px-6 py-3 border-none bg-blue-500 text-white rounded-lg text-base font-medium cursor-pointer transition-colors duration-300 hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed">{t('storyboard.step3.button')}</button>
          </div>
        </section>

        {/* Step 4: Visualization */}
        <section className="flex items-start mb-10 border-b border-gray-100 pb-10 last:border-b-0 last:pb-0">
          <div className="text-[2rem] font-bold text-gray-300 mr-8 leading-none">4</div>
          <div className="flex-grow">
            <h2 className="mt-0 text-[1.8rem] font-medium">{t('storyboard.step4.title')}</h2>
            <p className="text-gray-600 mb-4">{t('storyboard.step4.description')}</p>
            <div className="bg-gray-50 border border-dashed border-gray-300 rounded-lg p-8 text-center text-gray-500 my-4">
              <p>{t('storyboard.step4.placeholder')}</p>
            </div>
            <button className="px-6 py-3 border-none bg-blue-500 text-white rounded-lg text-base font-medium cursor-pointer transition-colors duration-300 hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed" disabled>{t('storyboard.step4.button')}</button>
          </div>
        </section>
      </div>

      <aside className="bg-gray-50 border border-gray-100 rounded-xl p-8">
        <h3 className="mt-0 border-b border-gray-300 pb-2">{t('storyboard.options.title')}</h3>
        <div className="mt-4">
          <label className="block font-medium mb-2" htmlFor="image-style">{t('storyboard.options.imageStyle')}</label>
          <select id="image-style" className="w-full p-2 rounded border border-gray-300">
            <option>{t('storyboard.options.styles.webtoon')}</option>
            <option>{t('storyboard.options.styles.photorealistic')}</option>
            <option>{t('storyboard.options.styles.watercolor')}</option>
          </select>
        </div>
        <div className="mt-4">
          <label className="block font-medium mb-2" htmlFor="tone">{t('storyboard.options.tone')}</label>
          <select id="tone" className="w-full p-2 rounded border border-gray-300">
            <option>{t('storyboard.options.tones.humorous')}</option>
            <option>{t('storyboard.options.tones.tragic')}</option>
            <option>{t('storyboard.options.tones.serious')}</option>
          </select>
        </div>
        <div className="mt-4 flex items-center">
          <input type="checkbox" id="char-lock" className="w-auto mr-2" />
          <label htmlFor="char-lock">★ {t('storyboard.options.characterLock')}</label>
        </div>
      </aside>
    </div>
  );
};

export default AIStoryboard;
